import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppDiv } from "./assets/css/app";
import Navbar from "./components/navbar";
import Sidebar from "./components/sideBar";
import AuthContext from "./services/authContext";
import { cancelPendingRequests, statusApi } from "./services/axios";
import Router from "./services/routes";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultAuthState = {
    status: "",
    email: "",
    dateTime: "",
    url: "",
    access: {},
  };
  const [auth, setAuth] = useState({
    ...defaultAuthState,
  });

  /**
   * Clears all accessible cookies from the browser.
   */
  // Generated by GitHub Copilot
  const clearCookies = () => {
    document.cookie.split(";").forEach((c) => {
      const cookieName = c.split("=")[0].trim();
      if (cookieName) {
        document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
        document.cookie = `${cookieName}=; path=/newweb/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
      }
    });
  };

  /**
   * Invalidates server session via backend endpoint (fire-and-forget).
   * Does not block frontend logout flow.
   */
  // Generated by GitHub Copilot
  const invalidateServerSession = () => {
    fetch("/web/logout", {
      method: "GET",
      credentials: "include",
    }).catch(() => {
      // Silently ignore errors; frontend logout continues regardless
    });
  };

  /**
   * Logs out entirely on the frontend layer and invalidates backend session.
   */
  // Generated by GitHub Copilot
  const logout = () => {
    cancelPendingRequests();
    // Invalidate server session (non-blocking)
    invalidateServerSession();
    // Clear local cookies
    clearCookies();
    // Clear auth state
    setAuth({ ...defaultAuthState });
    // Navigate to login
    navigate("/newweb/login", { replace: true });
  };

  // Generated by GitHub Copilot - Cancel in-flight requests whenever the route changes
  useEffect(() => {
    cancelPendingRequests();
  }, [location.pathname]);

  useEffect(() => {
    statusApi
      .get("web/status")
      .then(function (res) {
        console.log(res);
        const arr = res.data.split("|");
        const obj = {
          status: arr[0],
          email: arr[1],
          dateTime: arr[2],
          url: arr[0] === "OK" ? "" : arr[3],
          access: (arr[4] && arr[4] !== "NULL") ? JSON.parse(arr[4]) : "{}",
        };
        setAuth(obj);

        if (arr[0] === "OK" && location.pathname.startsWith("/newweb/login")) {
          navigate("/newweb/");
        }

        if (arr[3].includes("changepass")) {
          navigate("/newweb/changepass");
        }
        if (arr[3].includes("logout")) {
          setAuth({ ...defaultAuthState });
          navigate("/newweb/login", { replace: true });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [location.pathname, navigate]);

  const showShell =
    !location.pathname.startsWith("/newweb/login") && auth.status === "OK";

  return (
    <AuthContext.Provider value={{ auth, logout }}>
      {showShell ? (
        <AppDiv>
        <Sidebar />
        <div className="content">
          <Navbar />
          <Router />
        </div>
        </AppDiv>
      ) : (
        <Router />
      )}
    </AuthContext.Provider>
  );
}

export default App;
